import { render } from "./Keyboard.vue?vue&type=template&id=2eb33e1d&scoped=true"
import script from "./Keyboard.vue?vue&type=script&lang=js"
export * from "./Keyboard.vue?vue&type=script&lang=js"

import "./Keyboard.vue?vue&type=style&index=0&id=2eb33e1d&lang=css"
import "./Keyboard.vue?vue&type=style&index=1&id=2eb33e1d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eb33e1d"]])

export default __exports__